import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

interface CustomButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'text' | 'outlined' | 'contained' | 'primary' | 'secondary';
  loading?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
}

const Button: React.FC<CustomButtonProps> = ({
  variant = 'contained',
  loading = false,
  disabled,
  children,
  sx,
  ...props
}) => {
  // Map custom variants to MUI variants
  const getMuiVariant = (customVariant: string): 'text' | 'outlined' | 'contained' => {
    switch (customVariant) {
      case 'primary':
      case 'secondary':
        return 'contained';
      default:
        return customVariant as 'text' | 'outlined' | 'contained';
    }
  };

  const getColor = (customVariant: string): 'primary' | 'secondary' | undefined => {
    switch (customVariant) {
      case 'primary':
        return 'primary';
      case 'secondary':
        return 'secondary';
      default:
        return undefined;
    }
  };

  return (
    <MuiButton
      variant={getMuiVariant(variant)}
      color={getColor(variant)}
      disabled={disabled || loading}
      sx={{
        fontFamily: 'var(--font-heading)',
        fontWeight: 'var(--weight-medium)',
        textTransform: 'none',
        ...sx,
      }}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </MuiButton>
  );
};

export default Button; 